import { render, staticRenderFns } from "./ProjectDocumentIntegration.vue?vue&type=template&id=23de8b43"
import script from "./ProjectDocumentIntegration.vue?vue&type=script&lang=js"
export * from "./ProjectDocumentIntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports